import React from 'react'
import Box from '@material-ui/core/Box';

interface Props {
  status: string
  icon: React.ReactNode;
}

class AnimateText extends React.Component<Props> {

  render() {
    const { status, icon } = this.props;

    if(status === 'preparing your video' || status === 'recording' || status === 'redirecting') {
      return (
        <div>
            <Box
              position='absolute'
              top='5%'
              left='50%'
              style={{ transform: 'translate(-50%, -50%)' }}
            >
              <Box display='flex'>
                <Box>
                  <Box mx={1}>{icon}</Box>
                </Box>              
                {status.split("").map((character: string, index: number) => {
                  return(
                    <Box key={index}> 
                      <Box mx={.5}>{character}</Box>
                    </Box>);
                })}
              </Box>
          </Box>
      </div>
      );
    } else {
      return <span />
    }
  }

  }

export default AnimateText;  